import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function VaultFillIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M12 2c.43 0 .85.133 1.201.38l.146.114.008.006c.83.72 1.839 1.405 2.868 1.904 1.038.505 2.037.792 2.865.792A1.91 1.91 0 0 1 21 7.113v5.844c0 2.757-.983 4.89-2.556 6.515-1.549 1.6-3.634 2.675-5.81 3.426l-.006.003c-.406.137-.847.13-1.25-.013-2.18-.747-4.27-1.817-5.82-3.417C3.983 17.846 3 15.713 3 12.957V7.113a1.91 1.91 0 0 1 1.912-1.917l.318-.013c.76-.063 1.64-.34 2.551-.783 1.03-.5 2.038-1.184 2.865-1.9l.007-.006C11.031 2.174 11.51 2 12 2m0 6.848c-1.243 0-2.25 1.022-2.25 2.283 0 .936.555 1.74 1.35 2.093l-.817 2.535a1 1 0 0 0 .952 1.306h1.535a1 1 0 0 0 .95-1.308l-.819-2.533h-.005a2.28 2.28 0 0 0 1.354-2.093c0-1.26-1.007-2.283-2.25-2.283" />
    </Icon>
  );
}

VaultFillIcon.displayName = 'VaultFillIcon';
